import type { GQL_ID, CommonSort } from '@@partner:types:graphql'
import type { ProductAttribute } from '@@partner:types:app'
import type { ResponsiveTableColumn } from '@components/common/ResponsiveTable/ResponsiveTable'

import React from 'react'
import { Button } from 'rsuite'
import { Link } from 'react-router-dom'
import ResponsiveTable from '@components/common/ResponsiveTable/ResponsiveTable'

import { SORT_ORDER_DESC } from '@@partner:config/graphql'

export interface ProductAttributesTableProps {
  productAttributes: ProductAttribute[]
  loading: boolean
  tableSort: CommonSort
  onSortColumn?: (dataKey: string, sortType?: 'asc' | 'desc') => void
  generateEditUrl: (productAttributeId: GQL_ID) => string
}

export default function ProductAttributesTable ({
  productAttributes = [],
  loading = true,
  tableSort,
  onSortColumn,
  generateEditUrl
}: ProductAttributesTableProps) {
  const columns: ResponsiveTableColumn<ProductAttribute>[] = [
    {
      dataKey: 'id',
      header: 'ИД',
      sortable: true,
      flexGrow: 1,
      isCardBadge: true
    },
    {
      dataKey: 'name',
      header: 'Название',
      sortable: true,
      flexGrow: 2,
      isCardTitle: true
    },
    {
      dataKey: 'filter_name',
      header: 'Имя в фильтре',
      sortable: true,
      flexGrow: 2
    },
    {
      dataKey: 'is_filterable',
      header: 'Участвует в фильтре',
      sortable: true,
      flexGrow: 2,
      render: (attr: ProductAttribute) => attr.is_filterable ? 'Да' : 'Нет'
    },
    {
      dataKey: 'value_type',
      header: 'Тип',
      sortable: true,
      flexGrow: 2
    }
  ]

  const renderActions = (attr: ProductAttribute) => (
    <Button
      color="cyan"
      as={Link}
      to={generateEditUrl?.(attr.id)}
      size="xs"
    >
      Изменить
    </Button>
  )

  return (
    <ResponsiveTable<ProductAttribute>
      data={productAttributes}
      columns={columns}
      loading={loading}
      sortColumn={tableSort.fieldName}
      sortType={tableSort.direction === SORT_ORDER_DESC ? 'desc' : 'asc'}
      onSortColumn={onSortColumn}
      renderActions={renderActions}
      emptyMessage="Нет атрибутов"
    />
  )
}
